import React from "react";
import { useAuth } from "./authentication/AuthContext";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ImpersonationBanner = () => {
  const { isImpersonating, impersonateName, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  return (
    <div className="bg-orange-500 text-white px-4 h-8 flex items-center justify-between shadow-md z-[9999] fixed top-0 left-0 w-full text-xs">
      <div className="flex items-center gap-2">
        <span className="font-bold">⚠️ Impersonate Mode:</span>
        <span className="font-medium">
          Acting on behalf of{" "}
          <strong className="underline decoration-orange-300">{impersonateName || "a restaurant"}</strong>.
        </span>
      </div>
      <button
        onClick={() => {
          stopImpersonating();
          navigate("/superadmindashboard");
        }}
        className="flex items-center gap-1 bg-orange-700 hover:bg-orange-800 text-white px-2 py-0.5 rounded transition-colors font-semibold shadow-sm"
      >
        <LogOut className="w-3 h-3" />
        Stop
      </button>
    </div>
  );
};

export default ImpersonationBanner;
